import Vue from 'vue'
import App from './App.vue'
import router from "./router/router";
import './plugins/element.js'
import "../src/assets/styles/normalize.css";
import "../src/assets/styles/publicStyle.css";



Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();
router.afterEach((to,from) => {
  if(to.name === "Home" && from.name === "Login"){
     window.location.reload();
  }
  window.scrollTo(0,0);
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
